import React, { Fragment } from "react";
import * as images from "../../Constant/images";
import "./ContactSources.css";

const contactItems = [
  {
    id: "uan",
    label: "UAN",
    value: "03111147111",
    href: "tel:03111147111",
    icon: images.UAN,
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    value: "03111147111",
    href: "https://wa.me/923111147111",
    icon: images.whatsappicon,
    isExternal: true,
  },
  {
    id: "email",
    label: "Email",
    value: "support@faremakers.com",
    href: "mailto:support@faremakers.com",
    icon: images.Mail,
  },
];

const ContactSources = ({ variant = "default" }) => {
  const isModern = variant === "modern";

  return (
    <Fragment>
      <div
        className={`cs_wrap ${isModern ? "cs_wrap_modern" : "cs_wrap_default"}`}
      >
        <h5
          className={`cs_title ${isModern ? "cs_title_modern" : "cs_title_default"}`}
        >
          Need Any Help? Contact With Us
        </h5>
        <div
          className={`cs_list ${isModern ? "cs_list_modern" : "cs_list_default"}`}
        >
          {contactItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className={`cs_item ${isModern ? "cs_item_modern" : "cs_item_default"}`}
              target={item.isExternal ? "_blank" : undefined}
              rel={item.isExternal ? "noopener noreferrer" : undefined}
            >
              <img src={item.icon} alt={item.label} className="cs_icon" />
              <p className="cs_text">
                {item.label}: <span className="cs_value">{item.value}</span>
              </p>
            </a>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default ContactSources;
